import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=b675a316&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=b675a316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b675a316",
  null
  
)

export default component.exports